import { range } from "ramda";

export default function generateBlocksForJob({
  maxPhaseDuration,
  organizationSettings,
  showTravelTo,
  showTravelFrom,
}: {
  maxPhaseDuration: number;
  organizationSettings: Record<string, string>;
  showTravelTo: boolean;
  showTravelFrom: boolean;
}) {
  const averageWorkingHours = +organizationSettings?.average_working_hours_per_day || 8;

  if (!maxPhaseDuration || maxPhaseDuration <= 0) {
    return [
      {
        scheduledAt: "",
        blockLength: averageWorkingHours,
        showTravelTo,
        showTravelFrom,
      },
    ];
  }

  const daysRequired = maxPhaseDuration / averageWorkingHours;
  const blocksRequired = Math.ceil(daysRequired);

  const blocks = range(1, blocksRequired + 1).map((blockIndex) => {
    if (blockIndex === blocksRequired && daysRequired % 1 !== 0) {
      const remainder = (daysRequired % 1) * averageWorkingHours;
      return {
        scheduledAt: "",
        blockLength: +remainder.toFixed(2),
        showTravelTo,
        showTravelFrom,
      };
    }

    return {
      scheduledAt: "",
      blockLength: averageWorkingHours,
      showTravelTo,
      showTravelFrom,
    };
  });

  return blocks;
}
